import {Trans, useTranslation} from 'gatsby-plugin-react-i18next';

const Accessibility = () => {
    const { t } = useTranslation();
    return (
    <>
        <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 acc-1">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                    <h1 className="font-weight-semibold hero-heading mt-5 no-br">
                        <Trans>Wellness Without <br/>Boundaries!</Trans>
                    </h1>
                    <p className="hero-para font-weight-semibold no-br">
                        <Trans>Facilitate your employees' wellness journeys<br/> across devices, languages, and locations.</Trans>
                    </p>
                    <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                         </a>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="">
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-5">
                            <div className="col-12">
                                <div className="features-label red-font no-br">
                                <Trans>Mobile App</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading'><Trans>Wellness on the Move!</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>Enhance employee engagement with challenges, milestone tracking, and peer interactions, all conveniently accessible through your employees' mobile phones.</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-7 cta-img'>
                            <div className='d-flex justify-content-center'>
                                <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1701338418/VantageFit/2023/Accessibility-Wellness_on_the_Move`)} fetchPriority="high" alt="Wellness on the Move!" width="500" height="435"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex flex-row-reverse m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-6">
                            <div className="col-12">
                                <div className="features-label green-font">
                                <Trans>Access from Anywhere</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading'><Trans>Uninterrupted Connections!</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>Ensure smooth connections for your employees, whether in the office, at home, or working remotely, connecting via phones or the web!</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-6 cta-img'>
                            <div className='col-12 d-flex justify-content-center'>
                                <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1701338423/VantageFit/2023/accessibility-Uninterrupted_Connections" loading='lazy' alt="Uninterrupted Connections!" width="500" height="653"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-5">
                            <div className="col-12">
                                <div className="features-label orange-font">
                                <Trans>Multi-Language Support</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading'><Trans>Multi-Language Wellness Harmony!</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>A truly inclusive experience, offering multiple language supports to resonate with every employee.</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-7 cta-img'>
                            <div className='d-flex justify-content-center'>
                                <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1701339039/VantageFit/2023/vfit-feature-multi-lingual" loading='lazy' alt="Multilingual Wellness Harmony" width="500" height=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="section-heading-top cursive">
                <div className="text-center brk-sect-label mb-3"><Trans>Universal Accessibility:</Trans></div>
                <h2 className="section-heading font-weight-bold text-center mb-4"><Trans i18nKey="subtextfeat6">The&nbsp;<span className="charmonman green-clr">Game-Changer</span>&nbsp;</Trans>&nbsp;!</h2>
                <div className="section-para text-center"><Trans>Bridge the gap between technology and wellness, ensuring every employee feels seen and heard.</Trans></div>
            </div>
        </section>

        <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center no-br">
                    <Trans>Experience Wellness Without Limits!</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5 text-white">
                    <Trans>Encourage employees to dive into Vantage Fit for a transformative health journey.</Trans>
                    </p>
                    <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default Accessibility
